module.exports = __WEBPACK_EXTERNAL_MODULE_core_Debug_physicsViewer__;